import React, { SyntheticEvent } from 'react';
import { PhotoActionButton } from '../PhotoActionButton';

interface Props {
  onPhotoDelete?: (e: SyntheticEvent<Element, Event>) => void;
  onCloseCropper?: () => void;
}

export const DeleteControl: React.FC<Props> = ({ onPhotoDelete, onCloseCropper }) => {
  const onClickHandler = (e: SyntheticEvent<Element, Event>) => {
    onPhotoDelete && onPhotoDelete(e);
    onCloseCropper && onCloseCropper();
  };

  return (
    <PhotoActionButton onClickHandler={onClickHandler} ariaLabel="Delete Photo" iconName="delete" iconLabel="Delete" />
  );
};
